var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveSolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#003E6B",
    d: "m29,22.5c0,5.5228 -4.4772,10 -10,10c-5.5228,0 -10,-4.4772 -10,-10c0,-5.5228 10,-17 10,-17c0,0 10,11.4772 10,17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    strokeWidth: 3,
    stroke: "#ED3431",
    d: "m30.5,30.5l-23,-23"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_3",
    strokeWidth: 3,
    stroke: "#ED3431",
    r: 16,
    cy: 19.12514,
    cx: 18.87514
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveSolution);
export default __webpack_public_path__ + "static/media/Remove-Solution.000f423ab097ecf04c46b1696adde832.svg";
export { ForwardRef as ReactComponent };